const ytAccountLinking = {
  'YouTube Shopping Account Linking Title': 'YouTube ショッピング連携',
  'Store Setup Title': '1. ストア事前設定',
  'Store Setup Description':
    'Google Merchant Center アカウントで本ストアの商品情報を管理できることを確認したうえで、手順 2 の連携リンクをコピーし、提携先の YouTube チャンネルオーナーへ共有してください。 ',
  'Store Setup GMC Title': 'Google Merchant Center を連携',
  'Store Setup GMC Description':
    '設定完了後、本ストアの商品情報は連携された Google Merchant Center アカウントへ自動的に同期されます。\nYouTube ショッピングのチャンネルを追加した後は、ストアに連携している Google Merchant Center アカウントを変更しないでください。変更した場合は、チャンネルの再認証が必要となり、再認証完了後に新しい商品情報を取得できます。 <KnowMoreLink></KnowMoreLink>',
  'Learn More': '詳細を見る',
  'Setup Now': '有効化へ',
  'Store Setup GMC Account Connected':
    '連携済みの Google Merchant Center アカウント',
  'Store Setup GMC Finished': '連携済み',
  'Store Setup GMC ID Changed':
    'Google Merchant Center アカウント変更により、一部の連携チャンネルで再認証が必要です',
  'Store Setup Content API Title': 'Content API を有効化',
  'Store Setup Content API Description':
    'ストアの商品情報の変更は Content API を通じて Google Merchant Center にリアルタイムで反映されます。非表示の商品情報も自動的に同期されます。  <KnowMoreLink></KnowMoreLink>',
  'Store Setup Content API Status': 'Google Content API 連携状況',
  'Store Setup Content API Finished': '連携済み',
  'Connected Channels Title': '2. YouTube ショッピング チャンネル連携',
  'Connected Channels Description':
    '連携リンクを提携先の YouTube チャンネルオーナーへ共有してください。チャンネルオーナーが認証を完了すると、対象の YouTube チャンネル管理画面で商品を選択し、ライブ配信や動画に掲載できるようになります。 ',
  'Connected Channels Copy Link': '連携リンクをコピー',
  'Connected Channels Copy Success': 'コピーしました',
  'Connected Channels No Channels Connected':
    'ストアとの YouTube ショッピング連携が完了しているチャンネルはありません',
  'Connected Channels Channels Connected':
    '以下のチャンネルはストアとの YouTube ショッピング連携が完了しています',
  'Connected Channels Not Authorized': 'システム外認証',
  'Connected Channels Disconnect Tooltip':
    'このチャンネルとの連携を解除する場合は、カスタマーサクセス担当までお問い合わせください。',
  'Connected Channels Disconnect Channel': '連携を解除',
  'Connected Channels Disconnect Popup Title':
    'このチャンネルと「{{shopName}}」との YouTube ショッピング連携を解除してもよろしいですか？',
  'Connected Channels Disconnect Popup Description':
    '連携を解除すると、YouTube チャンネル上でストアの商品を表示できなくなります',
  'Connected Channels Cancel Disconnect': 'キャンセル',
  'Connected Channels Confirm Disconnect': '解除する',
  'Connected Channels Disconnect Channel Success': '解除しました',
  'Connected Channels Reconnect as GMC ID Changed':
    'Google Merchant Center アカウント変更により、チャンネルの再連携が必要です',
};

export default ytAccountLinking;
